var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 116,
    viewBox: "0 0 152 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 212836483"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5007",
    d: "M0.529297 6C0.529297 2.68629 3.21559 0 6.5293 0H145.469C148.782 0 151.469 2.68629 151.469 6V110C151.469 113.314 148.782 116 145.469 116H6.52929C3.21559 116 0.529297 113.314 0.529297 110V6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5008",
    x: 6.91992,
    width: 12.1661,
    height: 116,
    fill: "#63658E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5010",
    x: 77.1289,
    width: 24.759,
    height: 116,
    fill: "#63658E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5012",
    x: 28.1797,
    width: 4.8795,
    height: 116,
    fill: "#63658E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5011",
    x: 126.746,
    width: 15.6059,
    height: 116,
    fill: "#63658E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLine);
export default __webpack_public_path__ + "static/media/timeLine.32f70388a2bcbc3c983c946b426fd768.svg";
export { ForwardRef as ReactComponent };